import encUtf8 from 'crypto-js/enc-utf8';
import encBase64 from 'crypto-js/enc-base64';
import encMd5 from 'crypto-js/md5';

// utf8编码为base64
export const base64encode = (str) => {
    const words = encUtf8.parse(str); //  字符串到数组转换，解析明文
    return encBase64.stringify(words);
};

// base64解码为utf8
export const base64decode = (base64) => {
    const words = encBase64.parse(base64);
    return encUtf8.stringify(words);
};

export const md5 = function (str) {
    const words = encodeURIComponent(str)
        .replace(/!/g, '%21')
        .replace(/'/g, '%27')
        .replace(/\(/g, '%28')
        .replace(/\)/g, '%29')
        .replace(/\*/g, '%2A');
    return encMd5(words).toString();
};

